import React from "react";
import { Box, Text, Flex } from "@mantine/core";
import styles from "@scss/custom-components/custom-number-list.module.scss";
import { renderWithBreaks } from "@/src/utils/text-helpers";

interface NumberListItem {
  title: string;
  description: string;
}

interface CustomNumberListProps {
  items: NumberListItem[];
}

export const CustomNumberList: React.FC<CustomNumberListProps> = ({ items }) => {
  return (
    <Box className={styles.numberList}>
      {items.map((item, index) => (
        <Flex key={index} className={styles.listItem} align="flex-start" mb="xl">
          <Box className={styles.numberCircle}>
            <Text className={styles.number}>
              {String(index + 1).padStart(2, '0')}
            </Text>
          </Box>
          <Box className={styles.content}>
            <Text className={styles.title} fw={700}>
              {item.title}
            </Text>
            <Text className={styles.description}>
              {renderWithBreaks(item.description)}
            </Text>
          </Box>
        </Flex>
      ))}
    </Box>
  );
};
